export default __webpack_public_path__ + "static/callCenter_success-67b497b9fa14e41ae0e0fbe993fc03a2.png";